module.exports = __webpack_public_path__ + "static/img/10.7ad48c9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/3/sp/10.png
// module id = Fj2E
// module chunks = 0